import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as actions from "actions";
import IntlMessages from "util/IntlMessages";
import { isWebview } from "../../util/generalFunction";

class UserInfo extends React.Component {
  render() {
    const { user, resetApp, userLogout, history } = this.props;

    //
    return (
      <React.Fragment>
      {user ? user.role.name == "Customer" 
      ? (
        <div className="pt-3">
          {/* <div className="user-profile">
            <img
              className="user-avatar border-0 size-40"
              src={
                user.business && user.business.logo
                  ? user.business.logo.url
                  : "https://via.placeholder.com/150x150"
              }
              alt="User"
            />
            <div className="user-detail ml-2">
              <h4 className="user-name mb-0">
                {`${user.firstname} ${user.lastname}` || `${user.username}`}
              </h4>
              <small>{user.title}</small>
            </div>
          </div> */}
          <a
            className="dropdown-item text-muted"
            href="javascript:void(0)"
            onClick={() => {
              this.props.history.push("/profile");
              this.props.fillAdminCustomerSelctedDetails(JSON.parse(localStorage.getItem('user-data')));
            }}
          >
            <i className="zmdi zmdi-face zmdi-hc-fw mr-1" />
            <IntlMessages id="vibo.popup.myAccount" />
          </a>
          <a
            className="dropdown-item text-muted"
            href="javascript:void(0)"
            onClick={() => {
              this.props.history.push("/appointments");
            }}
          >
            <i className="zmdi zmdi-group-work zmdi-hc-fw mr-1" />
            <IntlMessages id="vibo.popup.myAppointments" />
          </a>
          <a
            className="dropdown-item text-muted"
            href="javascript:void(0)"
            onClick={() => {
              // userLogout();
              // resetApp();
              this.props.history.push("/logout");
            }}
          >
            <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-1" />
            <IntlMessages id="vibo.popup.logout" />
          </a>
        </div>
      )
      : (
        <div className="pt-3">
          {/* <div className="user-profile">
            <img
              className="user-avatar border-0 size-40"
              src={
                user.business && user.business.logo
                  ? user.business.logo.url
                  : "https://via.placeholder.com/150x150"
              }
              alt="User"
            />
            <div className="user-detail ml-2">
              <h4 className="user-name mb-0">
                {`${user.firstname} ${user.lastname}` || `${user.username}`}
              </h4>
              <small>{user.title}</small>
            </div>
          </div> */}
          {user.role.name == "Public" ? null
          :
          <a
            className="dropdown-item text-muted"
            href="javascript:void(0)"
            onClick={() => {
              this.props.history.push(user.role.name == 'Business Owner' ? "/admin/appointments" : isWebview() ? "/SuperAdminMobileScreen" : "/super-admin/businesses");
            }}
          >
            <i className="zmdi zmdi-group-work zmdi-hc-fw mr-1" />
            Go To Admin
          </a>
          }
          <a
            className="dropdown-item text-muted"
            href="javascript:void(0)"
            onClick={() => {
              // userLogout();
              // resetApp();
              this.props.history.push("/logout");
            }}
          >
            <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-1" />
            <IntlMessages id="vibo.popup.logout" />
          </a>
        </div>
      ) : null}
      
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ login }) => ({
  user: login.user,
});

const mapDispatchToProps = dispatch => ({
  userLogout: () => dispatch(actions.logoutUser()),
  fillAdminCustomerSelctedDetails: payload => dispatch(actions.fillAdminCustomerSelctedDetails(payload)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserInfo)
);



// WEBPACK FOOTER //
// ./components/CustomerUserInfo/index.js